"use client";

import { useAuthDialogStore } from "@/features/user/ui/store";
import { useRouter } from "@/i18n/navigation";
import { useSession } from "@/lib/client/auth/client";
import { Button } from "@/ui";

export const StartButton = ({ start }: { start: string }) => {
  const { data: session } = useSession();
  const { toggleAuthDialog } = useAuthDialogStore();
  const router = useRouter();
  const onDetailPageLinkClick = () => {
    if (!session?.user) {
      toggleAuthDialog(true);
    } else {
      router.push(`/affiliate/${session.user.id}`);
    }
  };

  return (
    <Button
      className={""}
      variant={"default"}
      onClick={onDetailPageLinkClick}
    >
      {start}
    </Button>
  );
};
